import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon      from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg      from "../../../asset/images/power&surveillance/star-plus/hero-bg.webp";
import HeroMobileImg  from "../../../asset/images/power&surveillance/star-plus/hero-bg-mobile.webp";
import StarPlusImg    from "../../../asset/images/power&surveillance/star-plus/star-plus.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .sp { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .sp-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .sp-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .sp-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .sp-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .sp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .sp-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .sp-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .sp-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .sp-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .sp-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .sp-subnav-link.sp-active { font-weight: 500; }
  .sp-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .sp-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .sp-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }

  /* DROPDOWN — position:absolute */
  .sp-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .sp-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .sp-subnav-dropdown-item:last-child { border-bottom: none; }
  .sp-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .sp-subnav-dropdown-item.sp-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .sp-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .sp-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .sp-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .sp-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .sp-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .sp-sidebar-overlay.open { display: block; }
  .sp-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .sp-sidebar.open { transform: translateX(0); }
  .sp-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .sp-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .sp-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sp-sidebar-nav { flex: 1; overflow-y: auto; }
  .sp-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .sp-sidebar-row:hover { background: #fafafa; }
  .sp-sidebar-row.active { color: #000000; font-weight: 400; }
  .sp-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .sp-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .sp-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .sp-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .sp-sidebar-subitem:last-child { }
  .sp-sidebar-subitem:hover { background: #fafafa; }
  .sp-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .sp-breadcrumb { padding: 60px 0 0 0; }
  .sp-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .sp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .sp-bc-item:hover { color: #EB2019; }
  .sp-bc-item.active { color: #202020; }
  .sp-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .sp-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .sp-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .sp-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .sp-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .sp-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* SCROLL ANCHOR */
  .sp-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .sp-section-content { padding: 80px 0 0 0; }
  .sp-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .sp-content-left { flex: 0 0 766px; }
  .sp-img-col {
    flex: 1;
    align-self: flex-start;;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sp-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sp-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .sp-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .sp-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .sp-tag {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #EB2019;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  .sp-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .sp-para + .sp-para { margin-top: 14px; }
  .sp-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .sp-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .sp-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .sp-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .sp-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .sp-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .sp-hero-bg        { display: block; }
    .sp-subnav         { top: 70px; }
    .sp-anchor         { scroll-margin-top: 110px; }
    .sp-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .sp-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .sp-hero              { height: 300px; }
    .sp-hero-content      { padding: 0 32px; }
    .sp-hero-title        { font-size: 26px; }
    .sp-breadcrumb        { padding: 28px 0 0 0; }
    .sp-breadcrumb-inner  { padding: 0 24px; }
    .sp-inner             { padding: 0 24px; }
    .sp-divider           { padding: 0px 32px 0px 32px; }
    .sp-divider:last-child { display: none; }
    .sp-divider-slim      { padding: 20px 24px 0 24px; }
    .sp-section-content   { padding: 40px 0 0 0; }
    .sp-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .sp-content-left      { flex: none; width: 100%; }
    .sp-features-tag      { margin: 24px 0 24px 0; }
    .sp-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .sp-img-col           { min-height: 260px; width: 100%; }
    .sp-img-wrap          { max-height: 450px; }
    .sp-red-title         { font-size: 24px; margin-bottom: 10px; }
    .sp-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .sp-para              { font-size: 14px; }
    .sp-para + .sp-para   { margin-top: 10px; }
    .sp-features-list li  { font-size: 14px; }
    .sp-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .sp-subnav           { display: none; }
    .sp-mobile-bar       { display: flex; height: 46px; }
    .sp-sidebar-header   { height: 46px; }
    .sp-anchor           { scroll-margin-top: 80px; }
    .sp-hero-bg          { display: none; }
    .sp-hero-bg-mobile   { display: block; }
    .sp-hero             { height: 370px; }
    .sp-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .sp-hero-title       { font-size: 22px; }
    .sp-breadcrumb       { padding: 22px 0 0 0; }
    .sp-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .sp-bc-item          { font-size: 14px; }
    .sp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .sp-inner            { padding: 0 16px; }
    .sp-divider          { padding: 0px 16px; }
    .sp-divider-slim     { padding: 30px 16px 0 16px; }
    .sp-section-content  { padding: 60px 0 0 0; }
    .sp-section-content:last-child { padding: 60px 0 0px 0; }
    .sp-divider:last-child { display: none; }
    .sp-content-grid:last-child { margin-bottom: 60px !important; }
    .sp-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .sp-img-wrap         { max-height: 260px; }
    .sp-red-title        { font-size: 20px; margin-bottom: 10px; }
    .sp-subtitle         { font-size: 16px; margin-bottom: 10px; }
    .sp-para             { font-size: 14px; }
    .sp-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", href: "/power-surveillance/liferaft-modular#lm-product-1" },
      { label: "Liferaft Modular 25kVA To 600kVA", href: "/power-surveillance/liferaft-modular#lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",   href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)", href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, active: true, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "sp-product-1",
    title:    "STAR+ SERIES (10 KVA – 500 KVA)",
    subtitle: "Uninterruptible Power Supply 3:3 Phase PF 0.8/0.9",
    tag:      "IGBT RECTIFIER DSP CONTROL",
    paras: [
      "The new Star+ range uses the latest DSP technology and programable to  suit a wide variety of electrical environment without impending its  performance. With the Star range, efficiency, reliability, and functionality  are enhanced to levels unattainable with the old analogue technology.  This technology not only create significant increase in MTBF, but also  capability of DSP to accurately manipulate signals at very high speed  which permits all the UPS subsystems to be controlled with greatly  increased precision.",
    ],
    features: [
      "Compatible with Lithium-ion Battery and BMS",
      "Low input current total harmonic distortion (THD)",
      "High input power factor",
      "High efficiency up to 94%",
      "Cold start function",
      "Static and maintenance by-pass switch",
      "Output short circuit and overload protection",
      "External REPO switch input",
      "192 event memory (92 event 4500alarms)",
      "Clock and Calender ( battery supported )",
      "Automatic battery test, remaining battery time indicator",
      "Temperature compensated charge system",
      "Regenerative backfeed function",
      "2 RS 232 serial ports and 12 dry contact outputs",
      "3 DSP controlled modular structure",
      "Optional SNMP and MODBUS adaptors",
      "Manufactured according to EC Directive; EN62040",
      "Full digital structure",
      "Small footprint",
      "Economode operation",
      "Fewer electronic components",
      "Output current limiting",
      "Advance diagnostic for the input",
      "Selectable input/output voltage /frequency /range",
      "Split by-pass input (second input)",
      "Output DC leakage protection",
      "Separate DSP for inverter control",
      "Separate DSP for the PFC",
      "3 level battery protection",
      "High charge current capacity",
      "Charge / discharge current indicator",
      "Advance remote control features",
    ],
    imgRight: true,
    imgSrc: StarPlusImg,
  },
];

/* ── SubnavItem — position:absolute dropdown, hover ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="sp-subnav-item">
        <a href={item.href || "#"} className={`sp-subnav-link${item.active ? " sp-active" : ""}`}>
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="sp-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a href={item.href || "#"} className={`sp-subnav-link${item.active ? " sp-active" : ""}`}>
        {item.label}
        <span className={`sp-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="sp-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`sp-subnav-dropdown-item${child.active ? " sp-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`sp-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`sp-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`sp-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="sp-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`sp-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function StarPlusSeries() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="sp">
        <section className="sp-hero">
          <img className="sp-hero-bg" src={HeroBgImg} alt="" />
          <img className="sp-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="sp-hero-content">
            <h1 className="sp-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      {/* SUBNAV outside .sp */}
      <nav className="sp-subnav" aria-label="Product categories">
        <div className="sp-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      {/* MOBILE BAR outside .sp */}
      <div className="sp-mobile-bar">
        <span className="sp-mobile-bar-title">Star+ Series</span>
        <button className="sp-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      <div
        className={`sp-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`sp-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="sp-sidebar-header">
          <span className="sp-sidebar-header-title">Star+ Series</span>
          <button className="sp-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="sp-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      {/* REST OF PAGE */}
      <div className="sp">
        <nav className="sp-breadcrumb" aria-label="Breadcrumb">
          <div className="sp-breadcrumb-inner">
            <a href="/" className="sp-bc-item">Home</a>
            <span className="sp-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="sp-bc-item">Business</a>
            <span className="sp-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="sp-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="sp-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="sp-anchor" />
            <section className="sp-section-content">
              <div className="sp-inner">
                <div
                  className="sp-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="sp-content-left">
                    <h2 className="sp-red-title">{product.title}</h2>
                    <h3 className="sp-subtitle">{product.subtitle}</h3>
                    {product.tag && <p className="sp-tag">{product.tag}</p>}
                    {product.paras.map((p, i) => (
                      <p key={i} className="sp-para">{p}</p>
                    ))}
                    <div className="sp-features-tag">
                      <div className="sp-features-tag-bar" />
                      <span className="sp-features-tag-text">Features</span>
                    </div>
                    <ul className="sp-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="sp-img-col">
                    <div className="sp-img-wrap">
                      {product.imgSrc &&
                        <img className="sp-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="sp-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}